import { Exception } from './exception';

export class MissingElementException extends Exception {}
